import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slideroot',
  templateUrl: './slideroot.component.html',
  styleUrls: ['./slideroot.component.scss']
})
export class SliderootComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
